App.factory('InsurancePlan', restmod => {
  return restmod.model('/insurance_plans')
})
